import {
  GoalsResponse,
  RewardResponse,
  TrialResult,
  TrialsResponse,
  type TrialAttempt,
} from "@empire/shared";
import { request } from "./client.js";

/** Guide rewards, Trials and the supply wagon (29 Sep 2026). */

export function fetchClaimedGoals(villageId: string, token: string): Promise<GoalsResponse> {
  return request(`/api/v1/villages/${villageId}/goals`, GoalsResponse, { token });
}

export function claimGoal(villageId: string, token: string, goalId: string): Promise<RewardResponse> {
  return request(`/api/v1/villages/${villageId}/goals/${goalId}/claim`, RewardResponse, {
    method: "POST",
    token,
    // The client always sends JSON, and Fastify refuses an empty JSON body.
    body: {},
  });
}

export function claimChest(villageId: string, token: string): Promise<RewardResponse> {
  return request(`/api/v1/villages/${villageId}/chest`, RewardResponse, { method: "POST", token, body: {} });
}

export function fetchTrials(villageId: string, token: string): Promise<TrialsResponse> {
  return request(`/api/v1/villages/${villageId}/trials`, TrialsResponse, { token });
}

export function attemptTrial(
  villageId: string,
  token: string,
  trialId: string,
  attempt: TrialAttempt
): Promise<TrialResult> {
  return request(`/api/v1/villages/${villageId}/trials/${trialId}`, TrialResult, {
    method: "POST",
    token,
    body: attempt,
  });
}
